export default function isTextNode(node: Node): node is Text {
    return node.nodeType === Node.TEXT_NODE;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect, expectTypeOf } = import.meta.vitest;
    describe('isTextNode', () => {
        test('results with false for non-text nodes', () => {
            expect(isTextNode(document)).toBe(false);
            expect(isTextNode(document.createProcessingInstruction('target', 'data'))).toBe(false);
            expect(isTextNode(document.createDocumentFragment())).toBe(false);
            expect(isTextNode(document.createAttribute('attr'))).toBe(false);
            expect(isTextNode(document.createComment('comment'))).toBe(false);
            expect(isTextNode(document.createElement('a'))).toBe(false);
        });

        test('results with true for text nodes', () => {
            expect(isTextNode(document.createTextNode('text'))).toBe(true);
        });

        test('justifies type of the given node to match the result of comparison', () => {
            const node: Node = document;

            isTextNode(node) ? expectTypeOf(node).toMatchTypeOf<Text>() : expectTypeOf(node).not.toMatchTypeOf<Text>();
        });
    });
}

// #endregion
